<template>
  <div style="padding: 20px; min-height: 630px; background-color: rgba(221, 225, 230, 1); border: solid 1px #ccc">
    <!--  -->
    <v-card v-if="list_access">
      <div class="row mb-2 mt-0">
        <div class="col-md-12">
          <div class="col-md-12" style="background:white; elevation-0">
            <div class="row pt-5">
              <div class="col-md-2 pt-0">
                <v-menu
                  ref="desde_selected"
                  v-model="desde_selected_open"
                  :close-on-content-click="false"
                  :close-on-click="false"
                  :return-value.sync="desde_selected"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                  clearable
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="desde_selected" label="Desde" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
                  </template>
                  <v-date-picker v-model="desde_selected" type="date" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="desde_selected_open = false"> Cancel </v-btn>
                    <v-btn text color="primary" @click="$refs.desde_selected.save(desde_selected)"> OK </v-btn>
                  </v-date-picker>
                </v-menu>
              </div>

              <div class="col-md-2 pt-0">
                <v-menu
                  ref="hasta_selected"
                  v-model="hasta_selected_open"
                  :close-on-content-click="false"
                  :close-on-click="false"
                  :return-value.sync="hasta_selected"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                  clearable
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="hasta_selected" label="Hasta" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" class="pt-0 mt-0"></v-text-field>
                  </template>
                  <v-date-picker v-model="hasta_selected" type="date" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="hasta_selected = false"> Cancel </v-btn>
                    <v-btn text color="primary" @click="$refs.hasta_selected.save(hasta_selected)"> OK </v-btn>
                  </v-date-picker>
                </v-menu>
              </div>

              <div class="col pt-0">
                <v-combobox v-model="supplier_selected" autocomplete="off" item-text="name" item-value="id" :items="suppliers" label="Proveedor" class="pt-0 mt-0" clearable></v-combobox>
              </div>

              <div class="col pt-0">
                <v-combobox v-model="cost_center_selected" autocomplete="off" item-text="name" item-value="id" :items="costs_centers" label="Centro de costos" class="pt-0 mt-0" clearable></v-combobox>
              </div>

              <div class="col pt-0">
                <v-combobox
                  v-model="sub_cost_center_selected"
                  autocomplete="off"
                  item-text="name"
                  item-value="id"
                  :items="sub_costs_centers"
                  label="Subcentro de costos"
                  class="pt-0 mt-0"
                  clearable
                ></v-combobox>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3 pt-2">
                <v-combobox v-model="receiver_selected" autocomplete="off" item-text="name" item-value="id" :items="receivers" label="Receptor" class="pt-0 mt-0" clearable></v-combobox>
              </div>
              <div class="col-md-3 pt-2" v-if="isProductCompany()">
                <v-combobox v-model="category_selected" autocomplete="off" item-text="name" item-value="id" :items="categories" label="Rubro" class="pt-0 mt-0" clearable></v-combobox>
              </div>

              <div class="col-md-6 pt-0 pb-0" v-if="isProductCompany()">
                <label class="caption">Tipo de gasto</label>
                <v-radio-group class="mt-0" v-model="stock_spent_selected" row>
                  <v-radio label="Con stock" :value="1" color="primary"></v-radio>
                  <v-radio label="Sin stock" :value="2" color="primary"></v-radio>
                  <v-radio label="Ambos" :value="3" color="primary"></v-radio>
                </v-radio-group>
              </div>

              <div class="col-md-10 pt-0">
                <label class="caption">Agrupar resultado por:</label>
                <v-radio-group class="mt-0" v-model="group_selected" row>
                  <v-radio v-if="isProductCompany()" label="Producto" :value="1" color="primary"></v-radio>
                  <v-radio label="Centro de Costo" :value="2" color="primary"></v-radio>
                  <v-radio label="Subcentro de Costo" :value="3" color="primary"></v-radio>
                  <v-radio label="Proveedor" :value="4" color="primary"></v-radio>
                  <v-radio label="Item del comprobante" :value="5" color="primary"></v-radio>
                </v-radio-group>
              </div>

              <div class="col-md-2 pt-4" style="display: flex; justify-content: end">
                <v-btn color="info" class="" @click="filter">Buscar</v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-card>
    <!--  -->
    <v-card v-if="list_access">
      <v-card-title>
        <v-btn color="blue-grey" class="mt-3" small dark :loading="dialog_export" @click="exportFile()"> Exportar <font-awesome-icon class="ml-2" icon="download" /></v-btn>

        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="list"
        :search="search"
        :loading="loading"
        loading-text="Cargando..."
        :options="{
          descending: true,
          itemsPerPage: 15,
        }"
        @pagination="updatePagination"
        :footer-props="{
          itemsPerPageOptions: [5, 10, 15, 50, -1],
        }"
      >
        <template v-slot:item="props">
          <tr>
            <td v-if="hasOwnProperty(props.item, 'cbte_fch')">{{ props.item.cbte_fch }}</td>
            <td v-if="hasOwnProperty(props.item, 'spent_number_label')">{{ props.item.spent_number_label }}</td>
            <td v-if="hasOwnProperty(props.item, 'product_name')">{{ props.item.product_name != null ? props.item.product_name : "-" }}</td>
            <td v-if="hasOwnProperty(props.item, 'descripcion')">{{ props.item.descripcion }}</td>
            <td v-if="hasOwnProperty(props.item, 'receiver_name')">{{ props.item.receiver_name }}</td>
            <td v-if="hasOwnProperty(props.item, 'cost_center_name')">{{ props.item.cost_center_name }}</td>
            <td v-if="hasOwnProperty(props.item, 'sub_cost_center_name')">{{ props.item.sub_cost_center_name }}</td>
            <td v-if="hasOwnProperty(props.item, 'supplier_name')">{{ props.item.supplier_name }}</td>
            <td v-if="hasOwnProperty(props.item, 'supplier_type')">{{ props.item.supplier_type != null ? props.item.supplier_type : "-" }}</td>
            <td v-if="hasOwnProperty(props.item, 'sku')">{{ props.item.sku }}</td>
            <td v-if="hasOwnProperty(props.item, 'name')">{{ props.item.name }}</td>
            <td v-if="hasOwnProperty(props.item, 'category')">{{ props.item.category }}</td>
            <td v-if="hasOwnProperty(props.item, 'subcategory')">{{ props.item.subcategory }}</td>
            <td v-if="hasOwnProperty(props.item, 'quantity')" class="text-right">{{ formatUtils.formatNumber(props.item.quantity) }}</td>
            <td v-if="isProductCompany() && hasOwnProperty(props.item, 'total_weight')" class="text-right">
              {{ props.item.total_weight > 0 ? props.item.total_weight + " " + props.item.weight_unit : "-" }}
            </td>
            <td v-if="hasOwnProperty(props.item, 'total_sin_iva')" class="text-right">{{ formatUtils.formatPrice(props.item.total_sin_iva) }}</td>
          </tr>
        </template>
        <template v-slot:no-results>
          <v-alert :value="true" color="error" icon="warning">
            {{ "Busqueda sin resultados - " + search }}
          </v-alert>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { generalService } from "@/libs/ws/generalService";
import { formatUtils } from "@/libs/utils/formatUtils";
import { emmiterService } from "@/libs/ws/emmiterService";
import { salesmanService } from "@/libs/ws/salesmanService";

import GenericMixin from "@/mixins/GenericMixin.vue";
import Title from "@/components/Title.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";
import SettingsMixin from "@/mixins/SettingsMixin.vue";

export default {
  components: {},
  mixins: [GenericMixin, RolMixin, ExportMixin, SettingsMixin],
  data() {
    return {
      Constant: Constant,
      formatUtils: formatUtils,
      service: generalService,
      page_title: "Compras por producto",
      modal_title: "Compras por producto",
      originalHeader: null,
      headers: [
        {
          text: "Fecha comprobante",
          align: "left",
          sortable: true,
          value: "cbte_fch",
          visible: false,
        },
        {
          text: "N° comprobante",
          align: "left",
          sortable: true,
          value: "spent_number_label",
          visible: false,
        },
        {
          text: "Producto",
          align: "left",
          sortable: true,
          value: "product_name",
          visible: false,
        },
        {
          text: "Descripcion",
          align: "left",
          sortable: true,
          value: "descripcion",
          visible: false,
        },

        {
          text: "Receptor",
          align: "left",
          sortable: true,
          value: "receiver_name",
          visible: false,
        },

        {
          text: "Centro de Costo",
          align: "left",
          sortable: true,
          value: "cost_center_name",
          visible: false,
        },
        {
          text: "Subcentro de Costo",
          align: "left",
          sortable: true,
          value: "sub_cost_center_name",
          visible: false,
        },

        {
          text: "Proveedor",
          align: "left",
          sortable: true,
          value: "supplier_name",
          visible: false,
        },
        {
          text: "Tipo",
          align: "left",
          sortable: true,
          value: "supplier_type",
          visible: false,
        },
        {
          text: "SKU",
          align: "left",
          sortable: true,
          value: "sku",
          visible: false,
        },
        {
          text: "Producto",
          align: "left",
          sortable: true,
          value: "name",
          visible: false,
        },
        {
          text: "Rubro",
          align: "left",
          sortable: true,
          value: "category",
          visible: false,
        },
        {
          text: "Subrubro",
          align: "left",
          sortable: true,
          value: "subcategory",
          visible: false,
        },
        {
          text: "Cantidad",
          align: "right",
          sortable: true,
          value: "quantity",
          visible: false,
        },
        {
          text: "Peso total",
          align: "right",
          sortable: true,
          value: "total_weight",
          visible: false,
        },
        { text: "Total S/IVA", value: "total_sin_iva", align: "right", visible: false },
      ],
      list: [],
      desde_selected: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().slice(0, 10),
      hasta_selected: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().slice(0, 10),
      desde_selected_open: false,
      hasta_selected_open: false,
      group_selected: 1,
      stock_spent_selected: 3,
      supplier_selected: null,
      cost_center_selected: null,
      receiver_selected: null,
      sub_cost_center_selected: null,
      category_selected: null,
      receivers: [],
      suppliers: [],
      categories: [],
      salesmans: [],
      costs_centers: [],
      sub_costs_centers: [],
    };
  },
  mounted() {
    this.originalHeader = JSON.parse(JSON.stringify(this.headers));
    this.setHeader();
    this.group_selected = this.isProductCompany() ? 1 : 2;
    this.loadList(this.service);
    this.loadSuppliers();
    this.loadCategories();
    this.loadReceivers();
    this.loadCostsCenter();
    this.loadSubCostsCenter();
  },
  methods: {
    setHeader() {
      var Header_Option_1 = ["sku", "name", "category", "subcategory", "quantity", "total_weight", "total_sin_iva"];
      var Header_Option_2 = ["cost_center_name", "total_sin_iva"];
      var Header_Option_3 = ["cost_center_name", "sub_cost_center_name", "total_sin_iva"];
      var Header_Option_4 = ["supplier_name", "supplier_type", "total_sin_iva"];
      var Header_Option_5 = [
        "cbte_fch",
        "spent_number_label",
        "supplier_name",
        "receiver_name",
        "descripcion",
        "product_name",
        "sub_cost_center_name",
        "cost_center_name",
        "quantity",
        "total_sin_iva",
      ];

      var Header_Product_Company = ["total_weight"];

      this.headers = this.originalHeader.filter((header) => {
        if (this.group_selected == 5 && Header_Option_5.includes(header.value)) {
          if (!this.isProductCompany() && Header_Product_Company.includes(header.value)) {
            return false;
          }
          return true;
        }
        if (this.group_selected == 4 && Header_Option_4.includes(header.value)) {
          if (!this.isProductCompany() && Header_Product_Company.includes(header.value)) {
            return false;
          }
          return true;
        }
        if (this.group_selected == 3 && Header_Option_3.includes(header.value)) {
          if (!this.isProductCompany() && Header_Product_Company.includes(header.value)) {
            return false;
          }
          return true;
        }
        if (this.group_selected == 2 && Header_Option_2.includes(header.value)) {
          if (!this.isProductCompany() && Header_Product_Company.includes(header.value)) {
            return false;
          }
          return true;
        }
        if (this.group_selected == 1 && Header_Option_1.includes(header.value)) {
          if (!this.isProductCompany() && Header_Product_Company.includes(header.value)) {
            return false;
          }
          return true;
        }
        return false;
      });
    },
    hasOwnProperty(obj, key) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        return true;
      }
    },
    getFilterParams() {
      const param = {
        from: this.desde_selected,
        to: this.hasta_selected,
        supplier: this.supplier_selected != null ? this.supplier_selected.id : null,
        cost_center: this.cost_center_selected != null ? this.cost_center_selected.id : null,
        sub_cost_center: this.sub_cost_center_selected != null ? this.sub_cost_center_selected.id : null,
        receiver: this.receiver_selected != null ? this.receiver_selected.id : null,
        category: this.category_selected != null ? this.category_selected.id : null,
        group: this.group_selected,
        stock_spent: this.isProductCompany() ? this.stock_spent_selected.toString() : "2",
      };
      return param;
    },
    filter() {
      this.loadList(this.service, this.getFilterParams());
    },
    loadReceivers() {
      emmiterService.list_for_stats({ enabled: true }).then((response) => {
        this.receivers = response.result;
      });
    },
    loadCostsCenter() {
      generalService.filter({}, Constant.SECTION_COSTS_CENTERS).then((response) => {
        this.costs_centers = response.result;
      });
    },
    loadSubCostsCenter() {
      generalService.filter({}, Constant.SECTION_SUB_COSTS_CENTERS).then((response) => {
        this.sub_costs_centers = response.result;
      });
    },
    loadSuppliers() {
      generalService.setSection(Constant.SECTION_SUPPLIERS);
      generalService
        .filter()
        .then((response) => {
          this.suppliers = response.result;
        })
        .catch((e) => {
          console.log("suppliers.filter error");
          console.log(e);
        });
    },
    loadCategories() {
      generalService.filter({}, Constant.SECTION_CATEGORIES).then((response) => {
        this.categories = response.result;
      });
    },
    loadList(service, param = null) {
      this.loading = true;

      if (param == null) {
        param = this.getFilterParams();
      }

      this.open_filter = false;
      service
        .query(param, Constant.SECTION_REPORTS + "/compras-por-periodo")
        .then((response) => {
          this.setHeader();
          this.list = response.result;
          this.loading = false;

          if (typeof this.selected !== "undefined") {
            this.selected = [];
          }
        })
        .catch((e) => {
          console.log("service.filter error");
          console.log(e);
          this.loading = false;
        });
    },
    exportFile() {
      var param = this.getFilterParams();
      param["export"] = true;
      this.exportExcel(Constant.SECTION_REPORTS + "/compras-por-periodo", param, "Compras-por-periodo.xlsx");
    },
  },
};
</script>
